/* eslint-disable react-refresh/only-export-components */
import { cn } from "@/lib/utils";

export enum ESpinningLoaderSize {
  SMALL = "small",
  MEDIUM = "medium",
}

interface ISpinningLoader {
  size?: ESpinningLoaderSize;
}

export const SpinningLoader = ({
  size = ESpinningLoaderSize.MEDIUM,
}: ISpinningLoader) => {
  return (
    <div
      className={cn(
        "w-[100px] h-[100px]",
        size === ESpinningLoaderSize.SMALL && "w-[50px] h-[50px]",
      )}
    >
      <div className="relative flex h-full items-center justify-center animate-spin-slow">
        <div
          className={cn(
            "rounded-full w-6 h-6 bg-[var(--spinning-loader-fill-1)]",
            size === ESpinningLoaderSize.SMALL && "w-4 h-4",
          )}
        />
        {/*
          NOTE: NSAI-6453 — the viewBox is square and centred on the ring
          (30,30), so the ring shares its centre with the spinning box and with
          the dot behind it. The old 60x63 box (plus a 3px nudge) put the
          rotation centre off the ring, which made it precess as it span and
          read as a smeared, off-centre circle. The trailing dot reaches
          y=58.7, so it still fits inside the 60-unit box.
        */}
        <svg
          className={cn(
            "absolute w-[70px] h-[70px]",
            size === ESpinningLoaderSize.SMALL && "w-[50px] h-[50px]",
          )}
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          data-testid="simple-spinning-loader"
        >
          <path
            d="M34.2356 51.2756C32.9569 51.5365 32.1282 52.7942 32.3868 54.0869C32.6488 55.3981 33.9176 56.2097 35.1729 55.9526C47.2402 53.4931 56 42.6762 56 30.236C56 15.7695 44.3364 4 30 4C15.6636 4 4 15.7695 4 30.236C4 42.6762 12.7598 53.4931 24.8273 55.9526C26.1199 56.2041 27.3548 55.3773 27.6134 54.0869C27.8719 52.7942 27.0433 51.5365 25.7645 51.2756C15.8921 49.2656 8.72727 40.4146 8.72727 30.236C8.72727 18.3991 18.2696 8.77019 30 8.77019C41.7304 8.77019 51.2727 18.3991 51.2727 30.236C51.2727 40.4146 44.1079 49.2656 34.2356 51.2756Z"
            fill="var(--spinning-loader-fill-2)"
          />
          <path
            d="M30 48.7002C27.2429 48.7002 25 50.9431 25 53.7002C25 56.4573 27.2429 58.7002 30 58.7002C32.7571 58.7002 35 56.4573 35 53.7002C35 50.9431 32.7571 48.7002 30 48.7002Z"
            fill="var(--spinning-loader-fill-3)"
          />
        </svg>
      </div>
    </div>
  );
};
